import * as React from "react";
import { Navigate, useRoutes } from "react-router-dom";
// auth
import CategoryPage from "../pages/auth/CategoryPage";
import ClientProfileSetup from "../pages/auth/ClientProfileSetup";
import FreelancerProfileSetup from "../pages/auth/FreelancerProfileSetup";
import LoginPage from "../pages/auth/LoginPage";
import SignupPage from "../pages/auth/SignupPage";
// auth

// import ClientFormPage from "../pages/ClientFormPage";
import CoursesDetailPage from "../pages/freelancer/courses/CoursesDetailPage";
import CoursesPage from "../pages/freelancer/courses/CoursesPage";
import CoursesVideoPage from "../pages/freelancer/courses/CoursesVideoPage";
// import FreelancerFormPage from "../pages/FreelancerFormPage";
import ClientLayout from "../layout/client";
import FreelancerLayout from "../layout/freelancer";
import NotificationsPage from "../pages/notifications";
import Chat from "../pages/chat";
import Home from "../pages/client/Home";
import InviteFreelancer from "../pages/client/InviteFreelancer";
import JobDetails from "../pages/client/JobDetails";
import JobPost from "../pages/client/JobPost";
import LandingPage from "../pages/client/LandingPage";
import ClientProfile from "../pages/client/Profile";
import ReviewProposals from "../pages/client/ReviewProposals";
import ShowFreelancer from "../pages/client/ShowFreelancer";
import Talents from "../pages/client/Talents";
import ViewJob from "../pages/client/ViewJob";
import Connects from "../pages/freelancer/Connects";
import Dashboard from "../pages/freelancer/Dashboard";
import Hire from "../pages/freelancer/Hire";
import MyJobs from "../pages/freelancer/MyJobs";
import MyProposals from "../pages/freelancer/MyProposals";
import FreelancerProfile from "../pages/freelancer/Profile";
import SubmitProposal from "../pages/freelancer/SubmitProposal";
import TransactionHistory from "../pages/freelancer/TransactionHistory";
// import AuthProtected from "./authProtected";
import MainLayout from "../layout/main";
import About from "../pages/main/About";
import Contact from "../pages/main/Contact";
import Privacy from "../pages/main/Privacy";
import Terms from "../pages/main/Terms";
import ForgotPage from "../pages/auth/ForgotPage";
import VerifyPage from "../pages/auth/verifyPage";
// import Discover from "../pages/client/Discover";
import DisputeResolution from "../pages/dispute/DisputeResolution";
import FileAComplain from "../pages/dispute/FileAComplain";
import ViewProposal from "../pages/freelancer/ViewProposal";
import ViewProposals from "../pages/freelancer/ViewProposals";
import { AUTH, CLIENT, FREELANCER, MAIN } from "./paths";

export default function Routes() {
  const element = useRoutes([
    // auth
    {
      path: "/auth",
      children: [
        {
          element: <Navigate to={"/auth/login"} />,
          index: true,
        },
        {
          path: "login",
          element: <AutoLogin comp={<LoginPage />} />,
        },
        {
          path: "signup",
          element: <AutoLogin comp={<SignupPage />} />,
        },
        {
          path: "forgot-password",
          element: <ForgotPage />,
        },
        { path: "account-type", element: <CategoryPage /> },
        { path: "client-profile", element: <ClientProfileSetup /> },
        { path: "freelancer-profile", element: <FreelancerProfileSetup /> },
      ],
    },
    // freelancer
    {
      path: "/freelancer",
      element: <ProtectedRoute comp={<FreelancerLayout />} access={"seller"} />,
      children: [
        {
          element: <Navigate to={"/freelancer/dashboard"} />,
          index: true,
        },
        {
          path: "dashboard",
          element: <Dashboard />,
        },
        { path: "notifications", element: <NotificationsPage /> },
        { path: "submitProposal", element: <SubmitProposal /> },
        { path: "profile", element: <FreelancerProfile /> },
        { path: "hire", element: <Hire /> },
        { path: "connects", element: <Connects /> },
        { path: "transaction-history", element: <TransactionHistory /> },
        { path: "my-jobs", element: <MyJobs /> },
        { path: "my-proposals", element: <MyProposals /> },
        { path: "view-proposals", element: <ViewProposals /> },
        { path: "view-proposal/:id", element: <ViewProposal /> },
        // dispute
        { path: "disputes", element: <DisputeResolution /> },
        { path: "file-a-complain/:id", element: <FileAComplain /> },
        // dispute

        // courses
        { path: "courses", element: <CoursesPage /> },
        { path: "course/:id", element: <CoursesDetailPage /> },
        { path: "lectures/:id", element: <CoursesVideoPage /> },
        // courses
      ],
    },
    // client
    {
      path: "/client",
      element: <ProtectedRoute comp={<ClientLayout />} access={"client"} />,
      children: [
        {
          element: <Navigate to={CLIENT.home} />,
          index: true,
        },
        {
          path: "home",
          element: <Home />,
        },
        { path: "notifications", element: <NotificationsPage /> },
        {
          path: "all-jobs",
          element: <JobPost />,
        },
        {
          path: "review-proposals/:id",
          element: <ReviewProposals />,
        },
        {
          path: "view-job",
          element: <ViewJob />,
        },
        {
          path: "job-details",
          element: <JobDetails />,
        },
        {
          path: "freelancer/:id",
          element: <ShowFreelancer />,
        },
        {
          path: "invite-freelancer/:id",
          element: <InviteFreelancer />,
        },
        {
          path: "talents",
          element: <Talents />,
        },
        // {
        //   path: "discover",
        //   element: <Discover />,
        // },
        {
          path: "profile",
          element: <ClientProfile />,
        },
        { path: "view-proposal/:id", element: <ViewProposal /> },

        // dispute
        { path: "disputes", element: <DisputeResolution /> },
        { path: "file-a-complain/:id", element: <FileAComplain /> },
        // dispute

        { path: "about-us", element: <About /> },
        { path: "contact-us", element: <Contact /> },
        { path: "terms-conditions", element: <Terms /> },
        { path: "privacy-policy", element: <Privacy /> },
      ],
    },

    // main
    {
      path: "/bnr",
      element: <MainLayout />,
      children: [
        { path: "landing", element: <LandingPage /> },
        { path: "about-us", element: <About /> },
        { path: "contact-us", element: <Contact /> },
        { path: "terms-conditions", element: <Terms /> },
        { path: "privacy-policy", element: <Privacy /> },
      ],
    },
    { path: "/", element: <Navigate to={MAIN.landing} /> },
    {
      path: "/verify/:id/:token",
      element: <VerifyPage />,
    },
    { path: "/chat", element: <Chat /> },
    { path: "*", element: <Navigate to={"/"} /> },
  ]);

  return element;
}

const ProtectedRoute = ({ comp, access }) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));
  if (token === null) return <Navigate to={AUTH.login} />;
  if (user?.user?.role === access) {
    return comp;
  } else {
    return <Navigate to={AUTH.login} />;
  }
};

const AutoLogin = ({ comp }) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));
  if (token === null) return comp;
  if (user?.user?.role === "seller") {
    return <Navigate to={FREELANCER.dashboard} />;
  } else if (user?.user?.role === "client") {
    return <Navigate to={CLIENT.home} />;
  } else {
    localStorage.clear();
    return <Navigate to={MAIN.landing} />;
  }
};
